import React from 'react';
import { Bill } from '../../PayBill/PayBillCreateForm';
import { useFormContext } from 'react-hook-form';
import { useTaskCreationContext } from '../../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const useResetTaxValueFromScanning = (
  scannedTax: Bill | null,
  loading: boolean,
  scanningSkipped: boolean,
  skipDocumentAnalysisReset?: boolean
) => {
  const { setValue } = useFormContext();
  const { client, isTaxBinding } = useTaskCreationContext();

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (scannedTax?.bpay?.referenceNumber) {
      setValue(
        'futureTaskInput.bpayReferenceNumber',
        scannedTax?.bpay?.referenceNumber
      );
    }
  }, [
    scannedTax?.bpay?.referenceNumber,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.lineItems) {
      setValue('futureTaskInput.lineItems', scannedTax?.lineItems, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.lineItems,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.amount) {
      setValue('futureTaskInput.amount', scannedTax?.amount, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [scannedTax?.amount, loading, scanningSkipped, skipDocumentAnalysisReset]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.issuedAt) {
      setValue('futureTaskInput.issuedAt', scannedTax?.issuedAt, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.issuedAt,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.dueAt) {
      setValue('dueAt', scannedTax?.dueAt, {
        shouldDirty: false,
        shouldTouch: false,
      });

      setValue('futureTaskInput.dueAt', scannedTax?.dueAt, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [scannedTax?.dueAt, loading, scanningSkipped, skipDocumentAnalysisReset]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.reference) {
      if (isTaxBinding) {
        return;
      }
      const newReference = `${client?.name} - ${scannedTax?.reference}`;
      setValue('reference', newReference, {
        shouldDirty: false,
        shouldTouch: false,
      });

      setValue('futureTaskInput.reference', newReference, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.reference,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
    client,
    isTaxBinding,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.taxDocumentType) {
      setValue('documentType', scannedTax?.taxDocumentType, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.taxDocumentType,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.taxSettlementStatus) {
      setValue('settlementStatus', scannedTax?.taxSettlementStatus, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.taxSettlementStatus,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.documentAnalysis?.task?.period) {
      setValue('period', scannedTax?.documentAnalysis?.task?.period, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.documentAnalysis?.task?.period,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);

  React.useEffect(() => {
    if (scanningSkipped || skipDocumentAnalysisReset) return;

    if (!loading && scannedTax?.documentAnalysis?.task?.year) {
      setValue('year', scannedTax?.documentAnalysis?.task?.year, {
        shouldDirty: false,
        shouldTouch: false,
      });
    }
  }, [
    scannedTax?.documentAnalysis?.task?.year,
    loading,
    scanningSkipped,
    skipDocumentAnalysisReset,
  ]);
};
